import { Grid, Typography } from '@mui/material'
import PublicTemplate from 'components/screens/PublicTemplate'
import React, { useEffect } from 'react'
import { TermsActions, TermsStoreStates } from '.'
import { Container, List } from './styles'

type TermsScreenProps = TermsActions & TermsStoreStates

const Terms = (props: TermsScreenProps) => {
  const { application, load } = props
  const { terms } = application

  // mounted actions
  useEffect(() => {
    load()
  }, [load])

  if (!terms) {
    return <div />
    // return <></>
  }

  return (
    <PublicTemplate>
      <Container container direction="column" spacing={1}>
        <Grid>
          <Typography variant="h3" align="center" sx={{ mb: 3 }}>
            利用規約
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="h6">{terms.header}</Typography>
        </Grid>
        <Grid>
          <List>
            {terms.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </List>
        </Grid>
        <Grid>
          <Typography variant="h6">{terms.dateStr}</Typography>
        </Grid>
      </Container>
    </PublicTemplate>
  )
}

export default Terms
